export default __webpack_public_path__ + "static/media/1864.bed6821a.png";